import { useSelector } from "react-redux";



const StatementPaymentDetail = (prpos) => {

    const ThemeConfiguration = useSelector((state) => state.Theme?.theme) || JSON.parse(localStorage.getItem("themeConfig") || "null");
    return (
        <>
            <div className="ar_review_confirm_payment">
                <div className="ar_header">
                    <img src={process.env.PUBLIC_URL + "/assets/images/LogoPngNew.svg"} alt="" />
                </div>
                <div className="ar_content d-flex flex-column align-items-center justify-content-center gap-10">
                    <div className="text-center">
                        <p className="heading fs-25 balck-5-clr pb-1-5 lh-normal">Add Payment Details</p>
                        <p className="text fs-13 balck-5-clr">Enter your card details below to complete your payment securely.</p>
                    </div>
                    <div className="">
                        <div className="py-10 my-2 w-444px d-flex flex-column gap-15">
                            <div className='input mb-0'>
                                <p className="text text-black font-m pb-3px">Amount to Pay</p>
                                <input type="text"
                                    className='form-control'
                                    name="SectionName"
                                    id="SectionName"
                                    disabled
                                />
                            </div>
                            <div className='input mb-0'>
                                <p className="text text-black font-m pb-3px">Card Number</p>
                                <input type="text"
                                    className='form-control'
                                    name="SectionName"
                                    id="SectionName"
                                />
                            </div>
                            <div className="d-flex align-items-center ">
                                <p className="text text-black font-m text-nowrap">Card Type</p>
                                <div className='d-flex gap-4 align-items-center justify-content-end w-100'>
                                    <div className="d-flex align-items-center gap-1">
                                        <div className="custom_check_box d-flex">
                                            <input
                                                type="checkbox"
                                                className="form-check-input m-0"
                                                name='IsAutoSubmittion'
                                                id='IsAutoSubmittion'
                                            />
                                        </div>
                                        <img src='/assets/images/MasterCard.svg' alt="" />
                                    </div>
                                    <div className="d-flex align-items-center gap-1">
                                        <div className="custom_check_box d-flex">
                                            <input
                                                type="checkbox"
                                                className="form-check-input m-0"
                                                name='IsAutoSubmittion'
                                                id='IsAutoSubmittion'
                                            />
                                        </div>
                                        <img src='/assets/images/Visa.svg' alt="" />

                                    </div>
                                    <div className="d-flex align-items-center gap-1">
                                        <div className="custom_check_box d-flex">
                                            <input
                                                type="checkbox"
                                                className="form-check-input m-0"
                                                name='IsAutoSubmittion'
                                                id='IsAutoSubmittion'
                                            />
                                        </div>
                                        <img src='/assets/images/AmericanExpress.svg' alt="" />

                                    </div>
                                    <div className="d-flex align-items-center gap-1">
                                        <div className="custom_check_box d-flex">
                                            <input
                                                type="checkbox"
                                                className="form-check-input m-0"
                                                name='IsAutoSubmittion'
                                                id='IsAutoSubmittion'
                                            />
                                        </div>
                                        <img src='/assets/images/UnionPay.svg' alt="" />
                                    </div>
                                </div>
                            </div>
                            <div className="d-flex align-items-center gap-12">
                                <div className='input mb-0 w-100'>
                                    <p className="text text-black font-m pb-3px">Expiration Date</p>
                                    <input type="text"
                                        className='form-control'
                                        name="SectionName"
                                        id="SectionName"
                                    />
                                </div>
                                <div className='input mb-0 w-100'>
                                    <p className="text text-black font-m pb-3px">Security Code</p>
                                    <input type="text"
                                        className='form-control'
                                        name="SectionName"
                                        id="SectionName"
                                    />
                                </div>
                            </div>

                            <div className='input mb-0'>
                                <p className="text text-black font-m pb-3px">Name on Card</p>
                                <input type="text"
                                    className='form-control'
                                    name="SectionName"
                                    id="SectionName"
                                />
                            </div>
                            <div className='input mb-0'>
                                <p className="text text-black font-m pb-3px">Country</p>
                                <input type="text"
                                    className='form-control'
                                    name="SectionName"
                                    id="SectionName"
                                />
                            </div>

                        </div>

                        <div className="d-flex justify-content-end pt-10">
                            <button className="btn btn-orange px-3 h-100 fs-14 rounded py-1-5">Pay Now</button>
                        </div>
                    </div>


                </div>

                <div className="hs_footer d-flex flex-column justify-content-center align-items-center">
                    <p className="heading ar-light-color lh-24">{ThemeConfiguration?.configuration?.company?.name},  All Rights Reserved.</p>
                    <p className="text ar-light-color lh-24">
                        <a href="https://starhealthcare.co/PrivacyPolicy" target="blank" className="text ar-light-color text-decoration-none ar-hover-text">Privacy Policy</a> | <a href="https://starhealthcare.co/BusinessAssociateAgreement" target="blank" className="text ar-light-color text-decoration-none ar-hover-text">BAA</a>.
                    </p>
                </div>


            </div> 
        </>
    )
}

export default StatementPaymentDetail